import { createPath, To } from 'history';

export function createHref(to: string | To) {
    return typeof to === 'string' ? to : createPath(to);
}
